import { AlertColor, Avatar, Box, Button, Divider, Grid, Typography } from "@mui/material";
import { useProfile } from "../../../../context/ProfileProvider/useProfile";
import { useTranslation } from "react-i18next";
import { SetUserImage } from "../../../../services/UserServices";
import { Delete, Edit, Upload } from "@mui/icons-material";
import { AvatarStyleTypeBuilder, UserPicture } from "../../../../components/UserPicture/UserPicture";
import { EditIcon } from "../../../../assets/icons/editIcon";
import { DeleteIcon } from "../../../../assets/icons/deleteIcon";

export interface IDataRenderPictureSection {
    setPopupOk: (set: boolean) => void;
    setAlertColor: (set: AlertColor) => void;
    setMessage: (set: string) => void;
}

export const DataRenderPictureSection: React.FC<IDataRenderPictureSection> = ({
    setAlertColor,
    setMessage,
    setPopupOk
}) => {

    const profile = useProfile();
    const { t } = useTranslation();

    const fileChooser = () => {
        document.getElementById("inputFile")!.click()
    }

    return (
        <Grid item xs={12}>
            <Box
                marginTop="18px"
            >
                <Typography
                    fontWeight="600"
                    fontSize="14px"
                    color="#2D2D2D"
                >
                    {t("MyData.Userimage")}
                </Typography>
            </Box>
            <Box
                marginTop="17px"
                display="flex"
            >
                <UserPicture
                    style={AvatarStyleTypeBuilder.rounded}
                    source={profile.userPicture == undefined || profile.userPicture == "" ? profile.picture : profile.userPicture}
                    username={profile?.username}
                />
                <Box
                    marginLeft="17px"
                >
                    <Typography
                        fontSize="14px"
                        sx={{ opacity: 0.6 }}
                    >
                        {t("MyData.UploadImageTerms")}
                    </Typography>
                    <input
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        style={{
                            display: "none"
                        }}
                        id="inputFile"
                        onChange={e => {
                            if(e.currentTarget.files![0])
                            SetUserImage(e.currentTarget.files![0])
                                .then(data => {
                                    profile.setUserPicture(data);
                                })
                                .catch((err) => {
                                    profile.setUserPicture("");
                                    setPopupOk(true);
                                    setAlertColor("error");
                                    setMessage(err.response.data)
                                })
                        }}
                    />
                    {profile.userPicture != "" ? (
                        <Box gap={2} marginTop="8px">
                            <Button
                                variant="contained"
                                sx={{
                                    background: "#22638D",
                                    marginRight: 2,
                                    fontWeight: "normal",
                                    padding: "6px 10px",
                                    textTransform: "none",
                                    fontSize: "14px",
                                    '&:hover': {
                                        background: "#467ca0"
                                    }
                                }}
                                startIcon={<EditIcon color="#FFFFFF" />}
                                onClick={e => {
                                    fileChooser()
                                }}
                            >
                                <Typography>
                                    {t("MyData.ChangeImage")}
                                </Typography>
                            </Button>
                            <Button
                                variant="outlined"
                                startIcon={<div style={{width: "14px"}}><DeleteIcon color="#22638d" /></div>}
                                onClick={e => {
                                    SetUserImage(undefined)
                                        .then(() => {
                                            profile.setUserPicture("");
                                        })
                                        .catch((err) => {
                                            profile.setUserPicture("");
                                            setPopupOk(true);
                                            setAlertColor("error");
                                            setMessage(err.response.data)
                                        })
                                }}
                                sx={{
                                    border: "1px solid #22638d",
                                    color: "#22638d",
                                    width: "110px",
                                    height: "36px",
                                    padding: "6px 10px",
                                    textTransform: "none",
                                    fontWeight: "normal",
                                }}
                            >
                                <Typography>
                                    {t("MyData.Remove")}
                                </Typography>
                            </Button>
                        </Box>
                    ) : (
                        <Button
                            variant="contained"
                            sx={{
                                marginTop: "8px",
                                background: "#22638D",
                                fontWeight: "normal",
                                padding: "6px 10px",
                                    textTransform: "none",
                                    '&:hover': {
                                        background: "#467ca0"
                                    }
                            }}
                            startIcon={<Upload />}
                            onClick={e => {
                                fileChooser()
                            }}
                        >
                            <Typography>
                                {t("MyData.Uploadimage")}
                            </Typography>
                        </Button>
                    )}
                </Box>
            </Box>
            <Divider
                sx={{
                    marginTop: "20px",
                    opacity: .2,
                    borderColor: "#22638D",

                }}
            />
        </Grid>
    )
}